// This is generated.  Alter it in blockGroups/workflowCriteriaElements/types/IntegerCriteria.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { propertyName, required = false } = hNode;

    // we could be on an update form, or on a new form, or nested somewhere
    // We just don't know what accessContext this would be enabling, nor how it is applied on a NS/REL
    // Security Modifiers (which would disabled certain accessContext) are processed generically
    // All we know is that Whatever propertyName is on this Criteria block
    // and how it is formatted.

    // Create TypeBox integer schemas for each operator with min/max constraints
    const eqSchema = Type.Optional(
      Type.Integer({
        title: 'Test for equality',
        'x-dataType': 'integer',
        'x-propertyName': '_eq',
        'x-optional': !required,
        minimum: hNode.min,
        maximum: hNode.max,
      }),
    );

    const gtSchema = Type.Optional(
      Type.Integer({
        title: 'Test for greater than',
        'x-dataType': 'integer',
        'x-propertyName': '_gt',
        'x-optional': !required,
        minimum: hNode.min,
        maximum: hNode.max,
      }),
    );

    const ltSchema = Type.Optional(
      Type.Integer({
        title: 'Test for less than',
        'x-dataType': 'integer',
        'x-propertyName': '_lt',
        'x-optional': !required,
        minimum: hNode.min,
        maximum: hNode.max,
      }),
    );

    // Create main criteria object containing all operators
    const criteriaSchema = Type.Object(
      {
        _eq: eqSchema,
        _gt: gtSchema,
        _lt: ltSchema,
      },
      {
        'x-id': hNode.id,
        title: hNode.title,
        'x-tooltip': hNode.tooltip,
        'x-propertyName': propertyName,
        'x-dataType': 'object',
        'x-optional': !required,
        additionalProperties: false,
      },
    );

    const partialTypeDefinition = {
      [propertyName]: required ? criteriaSchema : Type.Optional(criteriaSchema),
    };

    return [{}, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'workflowCriteriaElements',
  'IntegerCriteria',
  module.exports,
);
